import { Container, Modal as MantineModal, ModalProps as MantineModalProps } from "@mantine/core";
import { FC, PropsWithChildren } from "react";

import styles from "./styles.module.css";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";

interface ModalProps extends MantineModalProps {
  children: React.ReactNode;
  showCloseButton?: boolean;
}

const Modal = ({ children, showCloseButton, ...props }: ModalProps) => {
  return (
    <>
      <MantineModal
        centered
        padding={0}
        radius={0}
        classNames={{
          header: styles.modalHeader,
          close: styles.modalClose,
        }}
        closeButtonProps={{
          icon: !showCloseButton ? <></> : <SVGAsset name="modal-close" />,
        }}
        {...props}
      >
        {children}
      </MantineModal>
    </>
  );
};

export default Modal;

export const ModalCTAs: FC<PropsWithChildren> = (props) => <div className={styles.modalCtas} {...props} />;

export const ModalContent: FC<PropsWithChildren> = (props) => <Container {...props} />;
